import { motion } from "framer-motion";
import { Film, Instagram, Monitor, ArrowUpRight } from "lucide-react";

const services = [
    {
        icon: Film,
        num: "01",
        title: "Cinematische vastgoedvideo's",
        desc: "Wij transformeren jouw bestaande foto's naar professionele video's, volledig on-brand en klaar om te gebruiken.",
        tag: "Kernservice",
    },
    {
        icon: Instagram,
        num: "02",
        title: "Social media content",
        desc: "Reels, TikToks en Facebook video's, geoptimaliseerd per platform en klaar om te posten.",
        tag: "Social-ready",
    },
    {
        icon: Monitor,
        num: "03",
        title: "Horizontale website video's",
        desc: "Professionele brede video's ideaal voor websites, landingspagina's en advertenties.",
        tag: "Web & Ads",
    },
];

export const Services = ({ onCta }) => {
    return (
        <section
            id="services"
            data-testid="services-section"
            className="relative py-28 md:py-40 bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.7 }}
                    className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-16"
                >
                    <div className="max-w-2xl">
                        <p className="text-[11px] font-bold tracking-[0.3em] uppercase text-neutral-500 mb-5">
                            / 03 — Onze diensten
                        </p>
                        <h2 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold tracking-tighter text-black leading-[1.02]">
                            Wat wij bouwen.
                        </h2>
                    </div>
                    <button
                        data-testid="services-cta"
                        onClick={onCta}
                        className="self-start rounded-full bg-white border border-black/10 text-black font-medium px-6 py-3 text-sm transition-all duration-300 hover:bg-black hover:text-white hover:scale-[1.03] inline-flex items-center gap-2 group"
                    >
                        Plan mijn gesprek
                        <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                    </button>
                </motion.div>

                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
                    {services.map((s, i) => (
                        <motion.div
                            key={s.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: i * 0.08 }}
                            data-testid={`service-card-${i}`}
                            className="group relative p-8 md:p-10 rounded-3xl bg-neutral-50 border border-black/5 transition-all duration-500 hover:bg-black hover:-translate-y-1 hover:shadow-[0_30px_60px_-20px_rgba(0,0,0,0.3)] cursor-default overflow-hidden"
                        >
                            <div className="absolute top-6 right-6 font-heading text-[140px] font-bold tracking-tighter text-black/[0.03] group-hover:text-white/5 leading-none transition-colors pointer-events-none select-none">
                                {s.num}
                            </div>
                            <div className="relative flex items-start justify-between mb-8">
                                <div className="w-12 h-12 rounded-2xl bg-white border border-black/10 flex items-center justify-center group-hover:scale-110 transition-all duration-500">
                                    <s.icon className="w-5 h-5 text-black" />
                                </div>
                                <span className="text-[10px] tracking-[0.2em] uppercase font-bold text-neutral-500 group-hover:text-neutral-400 transition-colors">
                                    {s.tag}
                                </span>
                            </div>
                            <h3 className="relative font-heading text-2xl md:text-3xl font-bold text-black group-hover:text-white tracking-tight mb-3 transition-colors">
                                {s.title}
                            </h3>
                            <p className="relative text-neutral-600 group-hover:text-neutral-300 leading-relaxed transition-colors">
                                {s.desc}
                            </p>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
